import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { IonButtonCustomEvent } from '@ionic/core';
import { Subject, switchMap, takeWhile, tap, timer } from 'rxjs';
import { buttonSpinnerAnimation } from './../../../../../assets/animations';

type ButtonSize = 'default' | 'large' | 'small' | undefined;
type ButtonExpand = 'block' | 'full' | undefined;
type ButtonShape = 'round' | undefined;
type ButtonType = 'button' | 'reset' | 'submit';
type IconSlot = 'start' | 'end' | 'icon-only';
type ButtonColor = 'primary' | 'secondary' | 'tertiary' | 'white' | 'link';

@Component({
  selector: 'getm-button',
  templateUrl: './button.component.html',
  styleUrls: ['./button.component.scss'],
  animations: [
    buttonSpinnerAnimation
  ]
})
export class GetmButtonComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {

  @ViewChild('getmButtonRef', { read: ElementRef }) boton!: ElementRef;

  @Input() icon: string | undefined;
  @Input() iconSlot: IconSlot = 'icon-only';
  @Input() text: string = '';
  @Input() color: ButtonColor = 'primary';
  @Input() disabled: boolean = false;
  @Input() expand: ButtonExpand = undefined;
  @Input() shape: ButtonShape;
  @Input() type: ButtonType = 'button';
  @Input() size: ButtonSize = 'default';
  @Input() spinner: boolean = false;

  @Output() btnClick = new EventEmitter<void>();
  @Output() btnBlur = new EventEmitter<IonButtonCustomEvent<void>>();
  @Output() btnFocus = new EventEmitter<IonButtonCustomEvent<void>>();

  public animationCounter = 0;

  private spinner$ = new Subject<boolean>();

  constructor(private cdr: ChangeDetectorRef) {
    this.initAnimationStream();
  }

  ngOnInit(): void {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['spinner']) {
      // Pasamos el valor al flujo reactivo de forma inmediata
      this.spinner$.next(changes['spinner'].currentValue);
    }
  }

  ngAfterViewInit() {
    const ionButton = this.boton.nativeElement;
    if (ionButton && ionButton.shadowRoot) {
      const style = document.createElement('style');
      style.textContent = `
        .button-inner {
          gap: 12px !important;
        }
      `;
      ionButton.shadowRoot.appendChild(style);
    }
  }

  ngOnDestroy(): void {
    this.spinner$.next(false);
    this.spinner$.complete();
  }

  public onButtonClick = (): void => {
    if (!this.disabled) this.btnClick.emit();
  }

  public onButtonBlur = (event: IonButtonCustomEvent<void>): void => this.btnBlur.emit(event);

  public onButtonFocus = (event: IonButtonCustomEvent<void>): void => this.btnFocus.emit(event);

  private initAnimationStream(): void {
    this.spinner$.pipe(
      tap(isActive => {
        if (!isActive) {
          this.animationCounter = 0;
          this.cdr.detectChanges();
        }
      }),
      switchMap(isActive =>
        // timer(0, 750) emite el valor 0 INMEDIATAMENTE, y luego incrementa cada 750ms
        timer(0, 750).pipe(
          takeWhile(() => isActive),
          tap(() => {
            this.animationCounter++;
            this.cdr.detectChanges();
          })
        )
      )
    ).subscribe();
  }

}
